import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tihDisplayComponent]'
})
export class DisplayComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
